export class GoogleDriveRefreshTokenExpiredException extends Error {
  constructor(error) {
    super(error)
  }
}